import React, { Component } from 'react';
import './contact.css'
import { database } from '../../fire'
import Button from '@material-ui/core/Button';
import swal from 'sweetalert'


class Contact extends Component {
    constructor(props) {
        super(props)
        this.state = {
            name: '',
            email: '',
            message: '',
            btnDis: false,
        }
    }
    onchangef = (event) => {
        this.setState({
            name: event.target.value
        })
    }
    onchangef2 = (event) => {
        this.setState({
            email: event.target.value
        })
    }
    onchangef3 = (event) => {
        this.setState({
            message: event.target.value
        })
    }
    sendmessage = () => {
        let a = this.ValidateEmail(this.state.email)
        console.log(a)
        if (this.state.name && this.state.message && this.state.email) {
            if (a) {
                this.setState({
                    btnDis: true
                })
                const obj = {
                    name: this.state.name,
                    email: this.state.email,
                    message: this.state.message,
                }
                database.child('messages').push(obj).then((success) => {
                    this.setState({
                        name: '',
                        email: '',
                        message: '',
                        btnDis: false
                    })
                }).then(() => {
                    swal({
                        title: "Your message has been sent",
                        text: "We'll get back to you at the provided email address",
                        icon: "success",
                    });
                })
            }
            else {
                swal({
                    icon: "error",
                    title: "Please enter valid email address",
                });
            }
        }
        else {
            swal({
                icon: "error",
                title: "* Fields Required",
            });
        }
    }
    ValidateEmail = (mail) => {
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
            return (true)
        }
        return (false)
    }
    render() {
        return (
            <div className='ContactMainDiv'>
                <div className='ContactChild1'>
                    <p>GET IN TOUCH</p>
                    <p>muhazzib7@gmail.com Cell # 0341-2614496</p>
                </div>
                <div className='ContactChild2'>
                    <div className='ContactChild2Child1'>
                        <input type='text' placeholder='Your Name' onChange={this.onchangef} value={this.state.name} />
                    </div>
                    <div className='ContactChild2Child2'>
                        <input type='email' placeholder='Your Email' onChange={this.onchangef2} value={this.state.email} />
                    </div>


                </div>
                <div className='ContactChild3'>
                    <div className='ContactChild3Child1'>

                        <textarea placeholder='Your Message' onChange={this.onchangef3} value={this.state.message}></textarea>
                    </div>
                </div>

                <div className='ContactChild4'>
                    <div className='ContactChild4Child1'>

                        <Button variant="contained" color="primary" onClick={this.sendmessage} disabled={this.state.btnDis}>
                            SEND MESSAGE
                        </Button>
                    </div>

                </div>
            </div>

        );
    }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/containers/contact/contact.js